import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from "../../config/config";
import {map} from 'rxjs/operators';

@Injectable()
export class SmsMessageManageService {

  private _url = AppSettings.API_ENDPOINT;
  constructor(private http: HttpClient) {
  }

  fetchReasonService(AUTHTOKEN) {
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/fetchReason',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  updateReasonService(reasonId,update_Reason,AUTHTOKEN){
    const params = {reasonId:reasonId,reasonName:update_Reason};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/updateReason',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  deleteReasonService(reasonId,AUTHTOKEN){
    const params = {reasonId:reasonId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/deleteReason',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  fetchSubscriptionDetailsService(AUTHTOKEN){
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/schoolSubscriptionMessages',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  createReasonForSmsService(createReason,AUTHTOKEN){
    const params = {createReason:createReason};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/addReason',
      params, {headers: headers})
      .pipe(map(res => res));


  }

  sendSchoolWiseSms_Service(data, AUTHTOKEN) {
    const params = data;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/sendSchoolWiseMessage',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  sendClassWiseSmsToStudentService(messageData, AUTHTOKEN) {
    const params = messageData;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/sendClassWiseMessage',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  fetchClassStandardService(AUTHTOKEN) {
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/schoolclassmanagement/classlist',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  messageAvailableClassSection(classid, AUTHTOKEN) {
    const params = {classId: classid};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/classSectionName',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  fetchStudentListService(usrTyp,both, AUTHTOKEN) {
    const params = {appUser:usrTyp,both:both};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/fetchAllStudents',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  fetchStaffListService(usrTyp,both, AUTHTOKEN) {
    const params = {appUser:usrTyp,both:both};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/fetchAllStaffs',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  fetchSmsListService(AUTHTOKEN){
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/fetchSmsList',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  fetchSmsViewDetailsService(messageId,toWhom,AUTHTOKEN){
    const params = {messageId:messageId,toWhom:toWhom};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/viewSMSViewDetails',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  sendMessageToAllStudentService(messageData, AUTHTOKEN) {
    const params = messageData;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/sendMessageToAllStudent',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  sendStaffWiseSmsService(messageData, AUTHTOKEN) {
    const params = messageData;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/sendStaffWiseMessage',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  viewStudentListService(classId, AUTHTOKEN) {
    const params = {classId: classId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/viewSMS',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  sendSmsRequestService(messageData,AUTHTOKEN){
    const params = messageData;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/sendSmsRequest',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  fetchSMSForSchoolStatusService(AUTHTOKEN){
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/fetchSMSForSchoolStatus',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  sendMessageToAllStaffServices(data,AUTHTOKEN){
    const params = data;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/sendMessageToAllStaffs',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  fetchStaffListWithDesignationService(AUTHTOKEN){
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/fetchAllDesignation',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  sendSpecificDesignationService(data,AUTHTOKEN){
    const params = data;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/sendSpecificDesignation',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  getUserCountService(sendTo,userType,classList,AUTHTOKEN){
    const params = {userType:userType,sendTo:sendTo,classList:classList};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/getTotalUserCountInSchool',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  getClassesOfSchoolService(AUTHTOKEN){
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/getClassesOfSchool',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  sendMessageToEveryoneService(smsData,AUTHTOKEN){
    const params = smsData;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/message/sendMessageToEveryone',
      params, {headers: headers})
      .pipe(map(res => res));
  }
}
